import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import { Checkbox, Wrap, WrapItem, Text } from '@chakra-ui/react';

interface OccurrenceTypeCheckboxesProps {
  name: string;
  options: { id: string; value: string; label: string }[];
}

/**
 * Campo "Tipo de Ocorrência" (múltipla escolha). Não reaproveita
 * Global/InputCheckBox porque o Container dele tem `width: 50px` fixo
 * (feito para uma única opção curta em PainelAnalyticModule) — com 7
 * opções de texto longo isso quebra o layout (cada palavra numa linha).
 * Mesmo contrato de registro do Unform (getValue retorna os ids marcados).
 */
export function OccurrenceTypeCheckboxes({
  name,
  options,
}: OccurrenceTypeCheckboxesProps) {
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const { fieldName, registerField, defaultValue = [], error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      getValue: (refs: HTMLInputElement[]) =>
        refs.filter(ref => ref.checked).map(ref => ref.value),
      clearValue: (refs: HTMLInputElement[]) => {
        refs.forEach(ref => {
          // eslint-disable-next-line no-param-reassign
          ref.checked = false;
        });
      },
      setValue: (refs: HTMLInputElement[], values: string[]) => {
        refs.forEach(ref => {
          // eslint-disable-next-line no-param-reassign
          ref.checked = values.includes(ref.id);
        });
      },
    });
  }, [defaultValue, fieldName, registerField]);

  return (
    <Wrap spacing={4}>
      {options.map((option, index) => (
        <WrapItem key={option.id}>
          <Checkbox
            id={option.id}
            value={option.value}
            defaultChecked={defaultValue.includes(option.id)}
            ref={ref => {
              inputRefs.current[index] = ref as HTMLInputElement;
            }}
          >
            {option.label}
          </Checkbox>
        </WrapItem>
      ))}
      {error && (
        <Text color="red.400" fontSize="xs" w="100%">
          {error}
        </Text>
      )}
    </Wrap>
  );
}
